/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Download_CompleteInputs */

const en_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch download complete.`)
};

const fr_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement par lots terminé.`)
};

const de_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch-Download abgeschlossen.`)
};

const it_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download in batch completato.`)
};

const ru_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка пакета завершена.`)
};

const es_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga por lotes completada.`)
};

const zh_cn2_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量下载完成。`)
};

const ja_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括ダウンロードが完了しました。`)
};

const hi_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच डाउनलोड पूरा हो गया।`)
};

const pt_pt2_batch_download_complete = /** @type {(inputs: Batch_Download_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download em lote concluído.`)
};

/**
* | output |
* | --- |
* | "Batch download complete." |
*
* @param {Batch_Download_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_download_complete = /** @type {((inputs?: Batch_Download_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Download_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_download_complete(inputs)
	if (locale === "de") return de_batch_download_complete(inputs)
	if (locale === "it") return it_batch_download_complete(inputs)
	if (locale === "ru") return ru_batch_download_complete(inputs)
	if (locale === "es") return es_batch_download_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_download_complete(inputs)
	if (locale === "ja") return ja_batch_download_complete(inputs)
	if (locale === "hi") return hi_batch_download_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_download_complete(inputs)
	return en_batch_download_complete(inputs)
});